import { LinkPreviewContextResponseSchema } from '@sweetistics/contracts';
import type { z } from 'zod';

export type LinkPreviewContextResponseInput = z.input<typeof LinkPreviewContextResponseSchema>;
export type LinkPreviewContextResponseOutput = z.output<typeof LinkPreviewContextResponseSchema>;

export function serializeLinkPreviewContextResponse(
  payload: LinkPreviewContextResponseInput
): LinkPreviewContextResponseOutput {
  return LinkPreviewContextResponseSchema.parse(payload);
}
